import React, { Component } from "react";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Checkbox from "@material-ui/core/Checkbox";

export class EnhancedTableHead extends Component {
  state = {
    headRows: [
      { id: "name", numeric: false, disablePadding: false, label: "Label" },
      { id: "fieldType", numeric: false, disablePadding: false, label: "Type" },
      {
        id: "propertyValues",
        numeric: false,
        disablePadding: false,
        label: "Selection values",
      },
      { id: "value", numeric: false, disablePadding: false, label: "Value" },
      {
        id: "mandatory",
        numberic: false,
        disablePadding: false,
        label: "Mandatory",
      },
      { id: "actions", numeric: true, disablePadding: false, label: "Actions" },
    ],
  };

  render() {
    const { onSelectAllClick, numSelected, rowCount } = this.props;

    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            {this.props.slate && (
              <Checkbox
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
                inputProps={{ "aria-label": "Select all desserts" }}
              />
            )}
          </TableCell>
          {this.state.headRows.map((row) => (
            <TableCell
              key={row.id}
              align={
                row.id === "mandatory"
                  ? "center"
                  : row.numeric
                  ? "right"
                  : "left"
              }
              padding={row.disablePadding ? "none" : "default"}
            >
              {row.label}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
}
export default EnhancedTableHead;
